// Compact re-usable skeleton block for loading placeholders.
// Extracted from SwipeCards.js (iter 96) for reuse across modals.
export function Skel({ w = "100%", h = 14, mb = 6, radius = 8 }) {
  return <div className="zi-skel" style={{ width: w, height: h, marginBottom: mb, borderRadius: radius }} />;
}
